// test950
(950 && 0);
